/* Kimberly Dawn site kit JS, concept 2026-10-01. On Shopify this becomes assets/kd-kit.js (deferred). */
(function(){
  var doc=document.documentElement; doc.classList.add('js');
  // ?shot=1 is for local full page screenshots only: freezes full screen heros at a phone or laptop first screen height and shows every reveal
  if(/[?&]shot=1/.test(location.search)) doc.classList.add('shot');
  // Release moment: midnight Friday October 16 2026, viewer's local time (same as the live landing page countdown).
  // Preview the release day state of any page with ?released=1
  var RELEASE=new Date(2026,9,16,0,0,0).getTime(), forced=/[?&]released=1/.test(location.search);
  function out(){return forced||Date.now()>=RELEASE;}
  function flip(){var o=out();document.querySelectorAll('[data-pre]').forEach(function(e){e.hidden=o;});document.querySelectorAll('[data-post]').forEach(function(e){e.hidden=!o;});return o;}
  function pad(n){return (n<10?'0':'')+n;}
  function tick(){
    if(flip()) return;
    var s=Math.floor(Math.max(0,RELEASE-Date.now())/1000), v={d:Math.floor(s/86400),h:pad(Math.floor(s%86400/3600)),m:pad(Math.floor(s%3600/60)),s:pad(s%60)};
    document.querySelectorAll('[data-cd]').forEach(function(e){e.textContent=v[e.getAttribute('data-cd')];});
    setTimeout(tick,1000);
  }
  tick();

  // header height drives the full screen hero height (hero = viewport minus header)
  // transparent header over the full screen hero: goes solid white (berry logo) once the hero has scrolled away
  var hd=document.querySelector('.hdr.over'),fh0=document.querySelector('.fh');
  if(hd&&fh0){function sol(){hd.classList.toggle('solid',window.scrollY>fh0.offsetHeight-hd.offsetHeight-10||(document.getElementById('mainnav')||{}).className==='pad open');}
    sol();window.addEventListener('scroll',sol,{passive:true});window.addEventListener('resize',sol);
    var mb0=hd.querySelector('.menu');if(mb0)mb0.addEventListener('click',function(){setTimeout(sol,0);});}
  // hero title: letters arrive one by one
  document.querySelectorAll('[data-split]').forEach(function(el,wi){
    var d=+(el.getAttribute('data-split')||0);
    el.innerHTML=el.textContent.split('').map(function(c,i){return c===' '?' ':'<span class="ch" style="animation-delay:'+(d+i*0.045).toFixed(3)+'s">'+c+'</span>';}).join('');
  });
  // the hero photo holds still (Lauren 10/1). Pre save button opens the built in drawer under the hero.
  document.querySelectorAll('[data-ps]').forEach(function(b){
    var d=document.getElementById(b.getAttribute('aria-controls'));if(!d)return;
    function set(o){d.hidden=!o;b.setAttribute('aria-expanded',String(o));if(o)d.scrollIntoView({behavior:'smooth',block:'start'});}
    b.addEventListener('click',function(){set(d.hidden);});
    var c=d.querySelector('[data-ps-close]');if(c)c.addEventListener('click',function(){set(false);b.focus();});
  });

  // reveal on scroll
  var els=[].slice.call(document.querySelectorAll('[data-r]'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');io.unobserve(e.target);}});},{rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(e){io.observe(e);});
  } else els.forEach(function(e){e.classList.add('on');});

  // mobile menu
  var mb=document.querySelector('.hdr .menu'),nav=document.getElementById('mainnav');
  if(mb&&nav) mb.addEventListener('click',function(){var o=nav.classList.toggle('open');mb.setAttribute('aria-expanded',String(o));});

  // player tabs: only the visible outlet is loaded, so two things never play at once
  document.querySelectorAll('[data-player]').forEach(function(pl){
    var tabs=[].slice.call(pl.querySelectorAll('.ptabs button'));
    function show(k){
      tabs.forEach(function(b){var on=b.dataset.p===k;b.setAttribute('aria-selected',String(on));b.tabIndex=on?0:-1;});
      pl.querySelectorAll('[role=tabpanel]').forEach(function(p){var on=p.dataset.p===k;p.hidden=!on;
        p.querySelectorAll('iframe').forEach(function(f){if(on){if(!f.getAttribute('src')&&f.dataset.src)f.src=f.dataset.src;}else if(f.getAttribute('src')){f.dataset.src=f.src;f.removeAttribute('src');}});});
    }
    tabs.forEach(function(b,i){b.addEventListener('click',function(){show(b.dataset.p);});
      b.addEventListener('keydown',function(e){var d=e.key==='ArrowRight'?1:e.key==='ArrowLeft'?-1:0;if(!d)return;e.preventDefault();var n=tabs[(i+d+tabs.length)%tabs.length];n.focus();n.click();});});
    show(tabs[0].dataset.p);
    // Apple Music: tap a cover to load that record
    var am=pl.querySelector('.amlist'),af=pl.querySelector('.am iframe');
    if(am&&af) am.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){var u='https://embed.music.apple.com/us/album/'+b.dataset.am;af.dataset.src=u;af.src=u;am.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b);});});});
    // her PUBLIC lyric videos (isUnlisted:false, read 2026-10-01). Highway Heartache yLZ07r93s5c is still unlisted: add it only once it is public.
    var list=pl.querySelector('.ytlist'),fr=pl.querySelector('.ytframe iframe');
    if(list&&fr){
      [['two to two-step','cO3AZaJTX88'],['might be a god thing','1Y11RndZsJ8'],["quittin' on you",'w-jYRbjMeVc'],['kentucky kiss','XtOJOOivazY'],['days go by','lvuse2m1FdY']].forEach(function(v,i){
        var b=document.createElement('button');b.type='button';if(!i)b.className='on';b.setAttribute('aria-label','Play the '+v[0]+' lyric video');
        b.innerHTML='<img loading="lazy" alt="" src="https://i.ytimg.com/vi/'+v[1]+'/mqdefault.jpg"><span></span>';b.querySelector('span').textContent=v[0];
        b.addEventListener('click',function(){var u='https://www.youtube-nocookie.com/embed/'+v[1]+'?rel=0&playsinline=1&autoplay=1';fr.dataset.src=u;fr.src=u;list.querySelectorAll('button').forEach(function(x){x.classList.toggle('on',x===b);});});
        list.appendChild(b);
      });
    }
  });

  // concept stubs: forms submit nowhere in the preview
  document.querySelectorAll('form[data-stub]').forEach(function(f){f.addEventListener('submit',function(e){e.preventDefault();var ok=f.parentNode.querySelector('.ok');if(ok)ok.hidden=false;});});
  document.querySelectorAll('[data-year]').forEach(function(e){e.textContent=new Date().getFullYear();});
})();
